import { TileGridVariant } from 'components/TileGrid/TileGridVariant';
import { FilestackImageQuality } from 'types/Filestack';

type TileGridTileImagePropsBySize = {
  width: number;
  height: number;
  noCrop?: boolean;
  quality: FilestackImageQuality;
  borderRadius?: number;
  qaId: string;
  marginBottom: number;
};

export const tileGridTilePropsByVariant: Record<
  TileGridVariant,
  TileGridTileImagePropsBySize
> = {
  SMALL: {
    width: 238,
    height: 80,
    quality: 'high',
    qaId: 'small-image',
    marginBottom: 24,
  },
  LARGE: {
    width: 238,
    height: 238,
    quality: 'medium',
    borderRadius: 999,
    qaId: 'large-image',
    marginBottom: 36,
  },
  LARGE_RECTANGULAR: {
    width: 238,
    height: 238,
    quality: 'medium',
    borderRadius: 8,
    qaId: 'large-rectangular-image',
    marginBottom: 36,
  },
};
